<!--  -->
<template>
  <div class="box">
    <img src="/static/img/inqbg.png" alt="" class="banner">
    <ul>
       <li style="background-image:url(/static/img/rongybg.png)" @click="$router.push('/inquery?inqtype=ry')">
            荣誉信息查询
       </li> 
       <li style="background-image:url(/static/img/certbg.png)" @click="$router.push('/inquery?inqtype=px')">
            培训信息查询
       </li> 
       <li style="background-image:url(/static/img/ktibg.png)" @click="$router.push('/inquery?inqtype=kt')">
            课题信息查询
       </li> 
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  mounted: {},

  methods: {}
}

</script>
<style scoped>
.box {
    width:1300px;
    margin:auto;
}
.box .banner{
    width: 1300px;
height: 256px;
}
.box ul{
    display: flex;
    margin-top: 32px;
    margin-bottom: 250px;
}
.box ul li{
    display: inline-block;
    width: 416px;
    height: 150px;
    font-size: 26px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
line-height: 150px;
margin-left: 26px;
text-align: center;
letter-spacing: 4px;
cursor: pointer;
}
.box ul li:first-child{
    margin-left: 0px;
}
</style>